import { render, staticRenderFns } from "./DeathMarker.vue?vue&type=template&id=81d6ab3e&scoped=true&"
import script from "./DeathMarker.vue?vue&type=script&lang=js&"
export * from "./DeathMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d6ab3e",
  null
  
)

export default component.exports